import { Check, Info, Percent } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { Charity } from '../../../common/Fundraising/CharityPicker';
import { CouponCode, InvitationCode } from '../helpers';
import TicketSelector from './TicketSelector';
import UI from '../../../common/UI';
import useLocale from '../../../common/useLocale';

interface TicketsFormProps {
  preselectedCouponCode?: CouponCode | null;
  preselectedCharity?: Charity | null;
  invitationCode?: InvitationCode | null;
}

const TicketsForm = ({ preselectedCouponCode, preselectedCharity, invitationCode }: TicketsFormProps) => {
  const { t } = useTranslation();
  const { formatCurrency, formatNumber } = useLocale();

  return (
    <>
      {(preselectedCouponCode || preselectedCharity) && <UI.HR />}

      {preselectedCouponCode && (
        <>
          <UI.GridContainer sc={{ columns: '16px 1fr', gutter: 0.5 }}>
            <UI.Div>
              <UI.Icon sc={{ color: 'secondary', mt: -0.25 }}>
                <Percent />
              </UI.Icon>
            </UI.Div>
            <UI.Div>
              <UI.Strong>
                {t('tickets_form.coupon_activated')}
              </UI.Strong>
              <UI.Div>
                {preselectedCouponCode.value}
                {' ('}
                {preselectedCouponCode.coupon.type === 'absolute' && formatCurrency(preselectedCouponCode.coupon.value)}
                {preselectedCouponCode.coupon.type === 'percentage' && `${formatNumber(preselectedCouponCode.coupon.value)}%`}
                )
              </UI.Div>
            </UI.Div>
          </UI.GridContainer>

          <UI.HR />
        </>
      )}

      {preselectedCharity && (
        <>
          <UI.GridContainer
            sc={{
              columns: preselectedCharity.logo_url ? '16px 1fr fit-content(100px)' : '16px 1fr',
              gutter: 0.5,
            }}
          >
            <UI.Div>
              <UI.Icon sc={{ color: 'secondary', mt: -0.25 }}>
                <Check />
              </UI.Icon>
            </UI.Div>
            <UI.Div>
              <UI.Strong>
                {t('tickets_form.charity_activated')}
              </UI.Strong>
              <UI.Div>
                {preselectedCharity.title}
              </UI.Div>
            </UI.Div>
            {preselectedCharity.logo_url && (
            <UI.Div>
              <img
                src={preselectedCharity.logo_url}
                alt={preselectedCharity.title}
                style={{ display: 'block', objectFit: 'contain', width: '100%', height: 40 }}
              />
            </UI.Div>
            )}
          </UI.GridContainer>

          <UI.HR />
        </>
      )}

      <UI.FadeIn>
        <UI.FormGrid>
          {invitationCode?.invitation.description && (
            <UI.Info icon={<Info />}>
              <UI.HTML html={invitationCode?.invitation.description} />
            </UI.Info>
          )}

          <TicketSelector />
        </UI.FormGrid>
      </UI.FadeIn>
    </>
  );
};

export default TicketsForm;
